import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const PACKAGE_NAME = "com.shubhamarora9878.drivoloapp";
const IOS_APP_STORE_ID = "6759315211";

const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${PACKAGE_NAME}`;
const APP_STORE_URL = `https://apps.apple.com/app/id${IOS_APP_STORE_ID}`;

const Download = () => {
  return (
    <Box>
      <Box marginBottom={2}>
        <Typography variant={"h4"} sx={{ fontWeight: 700 }} align={"center"}>
          Take Drivolo with you
        </Typography>
        <Typography
          variant="h6"
          component="p"
          color="text.secondary"
          align={"center"}
        >
          Manage your driving school on the go. Available on Android and iOS.
        </Typography>
        <Box
          marginTop={3}
          display={"flex"}
          justifyContent={"center"}
          gap={2}
          flexWrap={"wrap"}
        >
          <Button
            component="a"
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant={"contained"}
            size={"large"}
            startIcon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                width={20}
                height={20}
              >
                <path d="M3.18 23.76c.3.17.65.19.97.07l11.65-11.65L12.14 8.5 3.18 23.76zm16.4-12.74c.27-.2.44-.5.44-.82s-.17-.62-.43-.82L17.3 8.5l-3.16 3.16 3.16 3.16 2.28-1.3.0-.5zM3.54.26C3.22.14 2.87.16 2.57.33L13.5 11.26l3.16-3.16L3.54.26zM2.18 1.06C2.07 1.28 2 1.52 2 1.78v20.44c0 .26.07.5.18.72l11.32-11.32L2.18 1.06z" />
              </svg>
            }
          >
            Google Play
          </Button>
          <Button
            component="a"
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant={"outlined"}
            size={"large"}
            startIcon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                width={20}
                height={20}
              >
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
            }
          >
            App Store
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Download;
